FG.tradableBits = tradableBits;

function tradableBits() {
    var NETWORK = FGT_CONFIG === 'Production' ? 'frontgate' : 'frontgatetest';
    var db = new FG.DB();
    var DB_KEY = 'cartData';
    var $tbits = $('#tbits-data');

    /**
     * Notify Tradable Bits about the items added to the cart
     */
    function trackEventAddToCart() {
        var personId = $tbits.data('personid');
        var cartData = getCartData('event');
        var orderKey = getTrackingKey();
        var isBranded = $tbits.data('isbranded');
        var encryptedEmail = $tbits.data('email');

        if (FG.User.isLoggedIn && personId && cartData && orderKey) {
            cartData.forEach(function (ticket) {
                var data = {
                    product_key: ticket.eventHubId,
                    customer_key: personId,
                    network: NETWORK,
                    order_key: orderKey,
                    is_branded: isBranded,
                    email: encryptedEmail,
                };

                loadTradableBitsImage('cart', data);
            });

            removeCartData('event');
        }
    }

    /**
     * Notify Tradable Bits about the packages added to the cart
     */
    function trackPackageAddToCart() {
        var personId = $tbits.data('personid');
        var cartData = getCartData('package');
        var orderKey = getTrackingKey();
        var isBranded = $tbits.data('isbranded');
        var encryptedEmail = $tbits.data('email');

        if (FG.User.isLoggedIn && personId && cartData && orderKey) {
            cartData.forEach(function (packageObj) {
                if ('items' in packageObj) {
                    packageObj.items.forEach(function (item) {
                        var data = {
                            product_key: item.eventHubId,
                            customer_key: personId,
                            network: NETWORK,
                            order_key: orderKey,
                            is_branded: isBranded,
                            email: encryptedEmail
                        };

                        loadTradableBitsImage('cart', data);
                    });
                }
            });

            removeCartData('package');
        }
    }

    function loadTradableBitsImage(event, params) {
        $('<img />', {
            src:
                'https://tradablebits.com/pixels/7177190/' +
                event +
                '?' +
                $.param(params),
            style: 'width:0;height:0;display:none',
        }).appendTo('body');
    }

    /**
     * Saves the cart data for an event
     * @param {Array} cartData
     */
    function saveEventCartData(cartData) {
        saveCartData('event', cartData);
    }

    /**
     * Saves the cart data for a package
     * @param {Array} cartData
     */
    function savePackageCartData(cartData) {
        saveCartData('package', cartData);
    }

    /**
     * Helper method to save the data into the db
     * @param {string} key
     * @param {Array} cartData
     */
    function saveCartData(key, cartData) {
        // if we already have cart data, we need to append the new data
        if (hasCartData(key)) {
            cartData = cartData.concat(getCartData(key));
        }

        var data = db.get(DB_KEY) || {};
        data[key] = cartData;
        db.set(DB_KEY, data);
    }

    /**
     * Retrieves the cart data for the specified key
     * @param key
     * @returns {Array}
     */
    function getCartData(key) {
        var data = db.get(DB_KEY) || {};
        return data.hasOwnProperty(key) ? data[key] : [];
    }

    /**
     * Checks to see if we have cart data, can be restricted key
     * @param key
     * @returns {boolean}
     */
    function hasCartData(key) {
        // if nothing in the db, then return false
        if (!db.has(DB_KEY)) {
            return false;
        }

        // if no key, then we're checking for both event and package cart data
        if (key === undefined) {
            return true;
        } else {
            var data = db.get(DB_KEY);
            return data.hasOwnProperty(key) && data[key].length > 0;
        }
    }

    /**
     * Removes all cart data from the db
     */
    function removeCartData(key) {
        if (key === undefined) {
            db.remove(DB_KEY);
        } else {
            var data = db.get(DB_KEY);
            data[key] = undefined;
            db.set(DB_KEY, data);
        }
    }

    /**
     * Saves the tracking key into the DB
     * @param trackingKey
     */
    function saveTrackingKey(trackingKey) {
        var data = db.get(DB_KEY) || {};
        data['trackingKey'] = trackingKey;
        db.set(DB_KEY, data);
    }

    /**
     * Retrieves the tracking key
     * @returns {*}
     */
    function getTrackingKey() {
        var data = db.get(DB_KEY);
        return data['trackingKey'];
    }

    return {
        trackEventAddToCart: trackEventAddToCart,
        trackPackageAddToCart: trackPackageAddToCart,
        saveEventCartData: saveEventCartData,
        savePackageCartData: savePackageCartData,
        hasCartData: hasCartData,
        removeCartData: removeCartData,
        saveTrackingKey: saveTrackingKey,
    };
}